export default {"src":"/_next/static/media/shop-deco-2.2588178a.svg","height":216,"width":336};